var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export const productInfo = {
    '-NLRioep8OhtKFJgttuP': {
        name: 'AC-AXION-X',
        numAudioOutputs: 16,
        volumeRanges: {
            trim: { max: 100, min: 70, round: 1 },
            volume: { max: 100, min: 40, round: 1 },
        },
    },
    '-N3ZigaA6jw5jkQnxw1x': {
        name: 'AC-CX42-AUHD',
        numAudioOutputs: 1,
        hasMicMuteToOutputs: true,
        volumeRanges: {
            // The documentation says the volume is 0-20, but the web UI shows 0-100.
            trim: { max: 100, min: 70, round: 1 },
            volume: { max: 100, min: 40, round: 1 },
        },
    },
    '-N3Ziga9JY_fbdyB8rop': {
        name: 'AC-CX62-AUHD',
        numAudioOutputs: 1,
        hasMicMuteToOutputs: true,
        volumeRanges: {
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-N0H2wRg5DpSFWLwrzLC': {
        name: 'AC-CX84-AUHD',
        numAudioOutputs: 4,
        hasMicMuteToOutputs: true,
        hasAllMics: true,
        volumeRanges: {
            trim: { max: 14, min: 0, round: 1 },
            volume: { max: 14, min: 0, round: 1 },
        },
    },
    '-LrVPz8uBr-X7Js7tCOB': {
        name: 'AC-MX42-AUHD',
        numAudioOutputs: 0,
        volumeRanges: {
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-LrVQ1i0ZFpwuqRgSbZW': {
        name: 'AC-MX44-AUHD',
        numAudioOutputs: 4,
        volumeRanges: {
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-LrVQ502De-lfdxijPBU': {
        name: 'AC-MX82-AUHD',
        numAudioOutputs: 2,
        volumeRanges: {
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-LrVQDRmlSD4ZmnmSj6x': {
        name: 'AC-MX1616-AUHD-NSFS',
        numAudioOutputs: 16,
        volumeRanges: {
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-LrVQAYSuEFum1aFM-5a': {
        name: 'AC-MX88-AUHD-GEN2',
        numAudioOutputs: 8,
        volumeRanges: {
            // No volume command in the API guide for this model, assuming same as most others.
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-LrVQ7sQYio3EhiTumAc': {
        name: 'AC-MX88-AUHD-NSFS',
        numAudioOutputs: 8,
        volumeRanges: {
            // No volume command in the API guide for this model, assuming same as most others.
            trim: { max: 20, min: 0, round: 1 },
            volume: { max: 20, min: 0, round: 1 },
        },
    },
    '-NBIWNYBTBvKlqhEFrpn': {
        name: 'AC-MX-44HDBT',
        numAudioOutputs: 4,
        volumeRanges: {
            trim: { max: 100, min: 70, round: 1 },
            volume: { max: 100, min: 40, round: 1 },
        },
    },
};
const allTypes = ['audioOutput', 'micOutput'];
const allowedTypes = {
    mics: allTypes,
    micsMuteStatus: allTypes,
    amplifier: ['audioOutput'],
    assistiveListeningMute: allTypes,
    assistiveListeningMuteStatus: allTypes,
    assistiveListeningVolume: ['audioOutput'],
    audioInputMute: allTypes,
    audioInputMuteStatus: allTypes,
    audioInputVolume: ['audioOutput'],
    overflowRoomMute: allTypes,
    overflowRoomMuteStatus: allTypes,
    overflowRoomVolume: ['audioOutput'],
    soundReinforcementMute: allTypes,
    soundReinforcementMuteStatus: allTypes,
    soundReinforcementVolume: ['audioOutput'],
    telephony: [],
    receiveGain: [],
    preset: [],
};
export class AvProSwitcher {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.log = log;
        // other class properties and constructor
        this.channels = [];
        this.defaultModelNumber = '-LrVPz8uBr-X7Js7tCOB';
        this.productInfo = productInfo[this.defaultModelNumber];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.detected = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.channels.map(channel => ({
                    filters: Object.fromEntries(Object.entries(allowedTypes).map(([key, types]) => [
                        key,
                        types.includes(channel.type),
                    ])),
                    name: channel.name,
                    channel: channel.key,
                    type: channel.type,
                }));
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('STA', /F\/W\s+Version\s*:\s*([\d\.]+)/i, tags);
                return match[1];
            }),
        };
        this.mute = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.getChannel(key);
                if (channel === undefined) {
                    this.log.error(`no channel for key ${key}`);
                    return false;
                }
                const [chanType, chanIndex] = key.split('.');
                const match = yield this.socket.send(`GET OUT${chanIndex} EXA${chanType === 'micOutput' ? ' MIC' : ''}`, /^OUT\d+\s+EXA\s+(?:MIC)?\s*(EN|DIS)/i, tags);
                return match[1].toLowerCase() === 'dis'; // disabled = muted
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.getChannel(key);
                if (channel === undefined) {
                    this.log.error(`no channel for key ${key}`);
                    return value;
                }
                const [chanType, chanIndex] = key.split('.');
                const match = yield this.socket.send(`SET OUT${chanIndex} EXA${chanType === 'micOutput' ? ' MIC' : ''} ${value ? 'DIS' : 'EN'}`, /^OUT\d+\s+EXA\s+(?:MIC)?\s*(EN|DIS)/i, tags);
                return match[1].toLowerCase() === 'dis';
            }),
            asyncHandlers: [
                {
                    regExp: /OUT(\d+)\s+EXA\s+MIC\s*(EN|DIS)/i,
                    callback: (match) => {
                        this.state.mutes.update(`micOutput.${match[1]}`, match[1].toLowerCase() === 'dis');
                    },
                },
                {
                    regExp: /OUT(\d+)\s+EXA\s+(EN|DIS)/i,
                    callback: (match) => {
                        this.state.mutes.update(`audioOutput.${match[1]}`, match[1].toLowerCase() === 'dis');
                    },
                },
            ],
            getKey: this.getKey.bind(this),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                return ((_b = (_a = this.productInfo) === null || _a === void 0 ? void 0 : _a.numAudioOutputs) !== null && _b !== void 0 ? _b : 0) > 0 ||
                    ((_d = (_c = this.productInfo) === null || _c === void 0 ? void 0 : _c.hasMicMuteToOutputs) !== null && _d !== void 0 ? _d : false);
            }),
            validate: this.validate.bind(this), // happens before constructor binding,
        };
        this.volume = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.getChannel(key);
                if (channel === undefined) {
                    this.log.error(`no channel for key ${key}`);
                    return 0;
                }
                const [, chanIndex] = key.split('.');
                const match = yield this.socket.send(`GET OUT${chanIndex} EXAUD LEV`, /OUT\d+\s+EXAUD\s+LEV\s*(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (key, volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const channel = this.getChannel(key);
                if (channel === undefined) {
                    this.log.error(`no channel for key ${key}`);
                    return 0;
                }
                const [, chanIndex] = key.split('.');
                const match = yield this.socket.send(`SET OUT${chanIndex} EXAUD LEV ${volume}`, /OUT\d+\s+EXAUD\s+LEV\s*(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            asyncHandlers: {
                regExp: /OUT\d+\s+EXAUD\s+LEV\s*(\d+)/i,
                callback: (match) => {
                    this.state.volumes.update(`audioOutput.${match[1]}`, parseInt(match[1], 10));
                },
            },
            getKey: this.getKey.bind(this),
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () { var _e, _f; return ((_f = (_e = this.productInfo) === null || _e === void 0 ? void 0 : _e.numAudioOutputs) !== null && _f !== void 0 ? _f : 0) > 0; }),
            range: (config, info) => __awaiter(this, void 0, void 0, function* () {
                if (this.productInfo === undefined) {
                    this.log.error(`audio controls not supported for this device`);
                    return { max: 20, min: 0, round: 1 };
                }
                if (info.volumeType === 'trim')
                    return this.productInfo.volumeRanges.trim;
                return this.productInfo.volumeRanges.volume;
            }),
            validate: this.validate.bind(this), // happens before constructor binding
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                var _g;
                const match = yield this.socket.send(`GET OUT${key} VS`, /OUT(\d+)\s+VS\s+IN(\d+)|CMD ERR/i, tags);
                return (_g = match[2]) !== null && _g !== void 0 ? _g : this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET OUT${key} VS IN${value}`, /OUT(\d+)\s+VS\s+IN(\d+)/i, tags);
                return match[2];
            }),
            asyncHandlers: {
                regExp: /OUT(\d+)\s+VS\s+IN(\d+)/i,
                callback: (match) => {
                    const key = match[1];
                    const value = match[2];
                    this.state.videoMatrixRoutes.update(key, value);
                },
            },
        };
        // polling
        this.polls = [
            {
                intervalMs: 6000,
                controls: ['videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onBeforeConfigure(config) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            // We use onBeforeConfigure instead of onConfigure because productInfo is used in hasControl
            // for mute and volume.
            this.productInfo = productInfo[(_a = config.modelNumber) !== null && _a !== void 0 ? _a : this.defaultModelNumber];
            this.channels.length = 0;
            if (this.productInfo) {
                const numAudioOutputs = this.productInfo.numAudioOutputs;
                for (let i = 0; i <= numAudioOutputs; i++) {
                    const chanKey = `audioOutput.${i}`;
                    this.channels.push({
                        name: i === 0 ? 'All Outputs' : `Output ${i}`,
                        key: chanKey,
                        type: 'audioOutput',
                    });
                }
                if (this.productInfo.hasMicMuteToOutputs) {
                    const hasAllMics = (_b = this.productInfo.hasAllMics) !== null && _b !== void 0 ? _b : false;
                    for (let i = hasAllMics ? 0 : 1; i <= this.productInfo.numAudioOutputs; i++) {
                        const chanKey = `micOutput.${i}`;
                        this.channels.push({
                            name: i === 0 ? 'Mic To All Outputs' : `Mic To Output ${i}`,
                            key: chanKey,
                            type: 'micOutput',
                        });
                    }
                }
            }
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, [
                {
                    errorCode: 'verifyFailed',
                    send: 'GET OUT1 VS',
                    next: /OUT(\d+)\s+VS\s+IN(\d+)/i,
                },
            ], credentials);
        });
    }
    // other class methods
    getChannel(key) {
        return this.channels.find(channel => channel.key === key);
    }
    getKey(config) {
        if (typeof config === 'string')
            return config;
        this.log.error(`invalid config: ${JSON.stringify(config)}`);
        return 'invalid';
    }
    validate(config, info) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = this.getKey(config);
            const channel = this.getChannel(key);
            if (channel === undefined)
                return 'missing';
            if (!allowedTypes[info.filter].includes(channel.type))
                return 'incompatible';
            return 'ok';
        });
    }
}
// static properties
AvProSwitcher.channelsConfigName = 'avProSwitcherControlChannels';
AvProSwitcher.driverType = 'socketDriver';
AvProSwitcher.key = '-LrVMuQ4zs1tpH0dKEvC';
AvProSwitcher.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
    sendTimeoutMs: 5000, // some models are slow to respond to commands
};
AvProSwitcher.socketOptions = [
    Object.assign(Object.assign({}, AvProSwitcher.baseSocketOptions), { port: 4999 }),
    Object.assign(Object.assign({}, AvProSwitcher.baseSocketOptions), { port: 23 }),
];
